import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Closing Costs",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.closingcosts.header"
      }
    ]
  },
  originationFee: {
    label: "Origination Fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.originationFeeAmount",
        variant: "filled"
      }
    ]
  },
  modificationFee: {
    label: "Modification Fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.modificationFeeAmount",
        variant: "filled"
      }
    ]
  },
  brokerFee: {
    label: "Broker Fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.brokerFeeAmount",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.brokerCompanyId",
        parentId: "brokers",
        label: "Brokers",
        hideLabel: true,
        displayWith: option => option.name,
        setValueWith: option => option.id,
        variant: "filled",
        style: { marginLeft: "16px" }
      }
    ]
  },
  lenderLegalFee: {
    label: "Lender Legal Fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.lenderLegalFeeAmount",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.lenderCounselCompanyId",
        parentId: "lenderCounsels",
        label: "Lender Counsels",
        hideLabel: true,
        displayWith: option => option.name,
        setValueWith: option => option.id,
        variant: "filled",
        style: { marginLeft: "16px" }
      }
    ]
  },
  borrowerLegalFee: {
    label: "Borrower Legal Fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.borrowerLegalFeeAmount",
        variant: "filled"
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        name: "details.borrowerCounselCompanyId",
        parentId: "borrowerCounsels",
        label: "Borrower Counsels",
        hideLabel: true,
        displayWith: option => option.name,
        setValueWith: option => option.id,
        variant: "filled",
        style: { marginLeft: "16px" }
      }
    ]
  },
  inspectionFee: {
    label: "Inspection Fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.inspectionFeeAmount",
        variant: "filled"
      }
    ]
  },
  appraisalFee: {
    label: "Appraisal Fee",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.appraisalFeeAmount",
        variant: "filled"
      }
    ]
  },
  rateLock: {
    label: "Rate Lock",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.rateLockFeeAmount",
        variant: "filled"
      }
    ]
  },
  hedgeCost: {
    label: "Hedge Cost",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.hedgeFeeAmount",
        variant: "filled"
      }
    ]
  },
  titleAmount: {
    label: "Title",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.titleAmount",
        variant: "filled"
      }
    ]
  },
  otherFees: {
    label: "Other Fees",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "closingCosts.otherAmount",
        variant: "filled"
      }
    ]
  }
};
